export function navigateTo(path: string) {
  const event = new CustomEvent('mfe_bloque_auth_navigation', {
    detail: { path },
  });
  window.dispatchEvent(event);
}
